/**
 *
 * TryThis
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typogragphy from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Colors from 'utils/colors';
import TryThisIcon from './try-this.svg';

const styles = () => ({
  root: {
    margin: '16px 0',
  },
  icon: {
    width: 31,
    height: 31,
    marginRight: 12,
  },
  text: {
    color: Colors.blue,
    fontSize: 16,
    fontWeight: 600,
  },
});

function TryThis(props) {
  const { classes } = props;
  return (
    <Grid container alignItems="center" className={classes.root}>
      <img src={TryThisIcon} className={classes.icon} alt="Try This" />
      <Typogragphy className={classes.text}>TRY THIS</Typogragphy>
    </Grid>
  );
}

TryThis.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(TryThis);
